(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[831],{

/***/ 51722:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 57275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ flip_clock)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/hooks/useEffectOnMount.ts
var useEffectOnMount = __webpack_require__(66050);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(51722);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/flip-clock/clock-utils.ts

var UPDATE_FREQ_MS = 100;
var getDigits = function(n, digits) {
    return "".concat(n).padStart(digits, "0").substr(-digits).split("").map(function(digit) {
        return parseInt(digit, 10);
    });
};
var naiveEqual = function(a, b) {
    if (a === null || b === null) {
        return false;
    }
    return Object.keys(a).every(function(key) {
        return a[key] === b[key];
    });
};
var getSecondsDifference = function(target, current) {
    return Math.round((target.getTime() - current.getTime()) / 1000);
};
var getSecondsFromClockState = function(state) {
    var days = state.days, hours = state.hours, minutes = state.minutes, seconds = state.seconds;
    return days * 86400 + hours * 3600 + minutes * 60 + seconds;
};
var getClockStateFromSeconds = function(timeInSeconds) {
    var days = Math.floor(timeInSeconds / (60 * 60 * 24));
    var divisorHours = timeInSeconds % (60 * 60 * 24);
    var hours = Math.floor(divisorHours / (60 * 60));
    var divisorMinutes = timeInSeconds % (60 * 60);
    var minutes = Math.floor(divisorMinutes / 60);
    var divisorSeconds = divisorMinutes % 60;
    var seconds = Math.ceil(divisorSeconds);
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
};
function getDateFromClockState(state) {
    if (state === null) {
        return new Date();
    }
    var seconds = getSecondsFromClockState(state);
    var currTime = Math.floor(new Date().getTime() / 1000);
    var targetTime = currTime + seconds * 1000;
    return new Date(targetTime);
}
function generateClockState(current, targetDate) {
    var target = dayjs_min_default()(targetDate || 0).toDate();
    return getClockStateFromSeconds(Math.max(0, getSecondsDifference(target, current)));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(29569);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/flip-clock/components/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    animation-name: ",
        ";\n    animation-duration: 0.3s;\n    animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n    animation-delay: 0s;\n    animation-iteration-count: 1;\n    animation-fill-mode: forwards;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    from {\n      transform: rotateX(0deg);\n    }\n    to {\n      transform: rotateX(-180deg);\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    from {\n      transform: rotateX(180deg);\n    }\n    to {\n      transform: rotateX(0deg);\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      display: flex;\n      position: relative;\n      justify-content: center;\n      width: 100% !important;\n      height: 50% !important;\n      overflow: hidden;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      align-items: flex-end;\n      span {\n        transform: translateY(50%);\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      align-items: flex-start;\n      span {\n        transform: translateY(-50%);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      /* stylelint-disable-next-line property-no-vendor-prefix */\n      -webkit-transform: translateZ(-100px); /* Avoids z-index bug in Safari */\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      justify-content: center;\n      position: absolute;\n      left: 0;\n      width: 100% !important;\n      height: 50% !important;\n      overflow: hidden;\n      backface-visibility: hidden;\n      transform-style: preserve-3d;\n      background-color: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 0%;\n      align-items: flex-end;\n      transform-origin: 50% 100%;\n      transform: rotateX(0deg);\n      span {\n        transform: translateY(50%);\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 50%;\n      align-items: flex-start;\n      transform-origin: 50% 0%;\n      transform: rotateX(180deg);\n      span {\n        transform: translateY(-50%);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  color: ",
        ";\n  font-family: Consolas, 'Liberation Mono', Courier, monospace;\n  font-weight: bold;\n  font-size: 56px;\n  line-height: ",
        ";\n  text-align: center;\n  border-radius: ",
        ";\n  background: linear-gradient(\n    to bottom,\n    rgba(16, 16, 16, 1) 0%,\n    rgba(64, 64, 64, 1) 100%\n  );\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  position: relative;\n  margin-left: 1px;\n  &:first-child {\n    margin-left: 0;\n  }\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    background: rgba(200, 200, 200, 0.3);\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-left: 15px;\n  &:first-child {\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  text-transform: uppercase;\n  margin-top: 5px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var unitwidth = "40px";
var unitheight = "60px";
var unitborderradius = "4px";
var animate = function(name) {
    return (0,styled_components_browser_esm.css)(_templateObject(), name);
};
var fold = (0,styled_components_browser_esm.keyframes)(_templateObject1());
var unfold = (0,styled_components_browser_esm.keyframes)(_templateObject2());
var Unit = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Unit",
    componentId: "sc-0-0"
})(_templateObject10(), unitwidth, unitheight, function(p) {
    return p.theme.colors.base0;
}, unitheight, unitborderradius, function(p) {
    return (p.position === "upper" || p.position === "lower") && (0,styled_components_browser_esm.css)(_templateObject3(), p.theme.colors.base900);
}, function(p) {
    return p.position === "upper" && (0,styled_components_browser_esm.css)(_templateObject4());
}, function(p) {
    return p.position === "lower" && (0,styled_components_browser_esm.css)(_templateObject5());
}, function(p) {
    return p.animation === "none" && (0,styled_components_browser_esm.css)(_templateObject6());
}, function(p) {
    return (p.animation === "in" || p.animation === "out") && (0,styled_components_browser_esm.css)(_templateObject7(), p.theme.colors.base900);
}, function(p) {
    return p.animation === "in" && (0,styled_components_browser_esm.css)(_templateObject8(), animate(fold));
}, function(p) {
    return p.animation === "out" && (0,styled_components_browser_esm.css)(_templateObject9(), animate(unfold));
});
var UnitContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnitContainer",
    componentId: "sc-0-1"
})(_templateObject11(), unitwidth, unitheight);
var UnitOuter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnitOuter",
    componentId: "sc-0-2"
})(_templateObject12());
var UnitWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnitWrapper",
    componentId: "sc-0-3"
})(_templateObject13());
var UnitLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).attrs({
    container: "div"
}).withConfig({
    displayName: "UnitLabel",
    componentId: "sc-0-4"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/components/flip-clock/components/flip-unit.tsx


var FlipUnit = function(param) {
    var position = param.position, digit = param.digit, _animation = param.animation, animation = _animation === void 0 ? "none" : _animation;
    return /*#__PURE__*/ react.createElement(Unit, {
        animation: animation,
        position: position
    }, /*#__PURE__*/ react.createElement("span", null, digit));
};

;// CONCATENATED MODULE: ./src/components/flip-clock/components/flip-unit-container.tsx



var FlipUnitContainer = function(param) {
    var previous = param.previous, current = param.current;
    var shuffle = !!(current % 2);
    // shuffle digits
    var digit1 = shuffle ? previous : current;
    var digit2 = !shuffle ? previous : current;
    // shuffle animations
    var anim1 = shuffle ? "in" : "out";
    var anim2 = !shuffle ? "in" : "out";
    return /*#__PURE__*/ react.createElement(UnitContainer, null, /*#__PURE__*/ react.createElement(FlipUnit, {
        position: "upper",
        digit: current
    }), /*#__PURE__*/ react.createElement(FlipUnit, {
        position: "lower",
        digit: previous
    }), /*#__PURE__*/ react.createElement(FlipUnit, {
        position: "first",
        digit: digit1,
        animation: anim1
    }), /*#__PURE__*/ react.createElement(FlipUnit, {
        position: "second",
        digit: digit2,
        animation: anim2
    }));
};

;// CONCATENATED MODULE: ./src/components/flip-clock/components/flip-unit-invalid.tsx



var FlipUnitInvalid = function(param) {
    var digits = param.digits, _char = param.char, char = _char === void 0 ? "-" : _char;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, new Array(digits).fill(char).map(function(c, i) {
        return(// eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ react.createElement(UnitContainer, {
            key: "invalid-".concat(i)
        }, /*#__PURE__*/ react.createElement(FlipUnit, {
            position: "upper",
            digit: c
        }), /*#__PURE__*/ react.createElement(FlipUnit, {
            position: "lower",
            digit: c
        })));
    }));
};

;// CONCATENATED MODULE: ./src/components/flip-clock/components/flip-unit-group.tsx





var FlipUnitGroup = function(param) {
    var currentDigit = param.currentDigit, previousDigit = param.previousDigit, numberOfDigits = param.numberOfDigits, label = param.label;
    if (isNaN(previousDigit) || isNaN(currentDigit)) {
        return /*#__PURE__*/ react.createElement(FlipUnitInvalid, {
            digits: numberOfDigits
        });
    }
    var ref = [
        getDigits(previousDigit, numberOfDigits),
        getDigits(currentDigit, numberOfDigits)
    ], previous = ref[0], current = ref[1];
    var renderDigits = new Array(numberOfDigits).fill(numberOfDigits);
    return /*#__PURE__*/ react.createElement(UnitOuter, null, /*#__PURE__*/ react.createElement(UnitWrapper, null, renderDigits.map(function(_, i) {
        return /*#__PURE__*/ react.createElement(FlipUnitContainer, {
            // eslint-disable-next-line react/no-array-index-key
            key: i,
            previous: previous[i],
            current: current[i]
        });
    })), label && /*#__PURE__*/ react.createElement(UnitLabel, null, label));
};

;// CONCATENATED MODULE: ./src/components/flip-clock/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-transform: translate3d(\n    0px,\n    0px,\n    0px\n  ); /* Avoids z-index bug in Safari */\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ClockContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ClockContainer",
    componentId: "sc-0-0"
})(styles_templateObject());

;// CONCATENATED MODULE: ./src/components/flip-clock/flip-clock.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var FlipClock = function(props) {
    var ref = _slicedToArray((0,react.useState)(function() {
        return generateClockState(new Date(Date.now() - 1000), props.targetDate);
    }), 2), current = ref[0], setCurrent = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(function() {
        return null;
    }), 2), previous = ref1[0], setPrevious = ref1[1];
    var lastUpdate = (0,react.useRef)(0);
    var updateRequest = (0,react.useRef)(0);
    var update = (0,react.useCallback)(function(time) {
        if (time - lastUpdate.current > UPDATE_FREQ_MS) {
            lastUpdate.current = time;
            var next = generateClockState(new Date(), props.targetDate);
            if (!naiveEqual(current, next)) {
                setPrevious(current);
                setCurrent(next);
            }
        }
        if (true) {
            updateRequest.current = window.requestAnimationFrame(update);
        }
    }, [
        current,
        props.targetDate
    ]);
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        if (current === null && true) {
            setCurrent(generateClockState(new Date(Date.now() - 1000), props.targetDate));
        }
    });
    (0,react.useEffect)(function() {
        if (true) {
            updateRequest.current = window.requestAnimationFrame(update);
        }
        return function() {
            return window.cancelAnimationFrame(updateRequest.current);
        };
    }, [
        current,
        props.targetDate,
        update
    ]);
    var daysLabel = props.daysLabel, hoursLabel = props.hoursLabel, minutesLabel = props.minutesLabel, secondsLabel = props.secondsLabel;
    return previous && current && /*#__PURE__*/ react.createElement(ClockContainer, {
        suppressHydrationWarning: true
    }, /*#__PURE__*/ react.createElement(FlipUnitGroup, {
        previousDigit: previous.days,
        currentDigit: current.days,
        numberOfDigits: 3,
        label: daysLabel
    }), /*#__PURE__*/ react.createElement(FlipUnitGroup, {
        previousDigit: previous.hours,
        currentDigit: current.hours,
        numberOfDigits: 2,
        label: hoursLabel
    }), /*#__PURE__*/ react.createElement(FlipUnitGroup, {
        previousDigit: previous.minutes,
        currentDigit: current.minutes,
        numberOfDigits: 2,
        label: minutesLabel
    }), /*#__PURE__*/ react.createElement(FlipUnitGroup, {
        previousDigit: previous.seconds,
        currentDigit: current.seconds,
        numberOfDigits: 2,
        label: secondsLabel
    }));
};
/* harmony default export */ const flip_clock = (FlipClock);


/***/ })

}]);